import React, { useEffect, useState } from "react";
import { Button, Col, Form, Modal, Row } from "react-bootstrap";
import { ErrorMessage, Field, FormikProvider, useFormik } from "formik";
import EducationDetails from "../RegistrationTabs/EducationDetails";
import SSC from "./SSC";
import Inter from "./Inter";
import Degree from "./Degree";
import PG from "./PG";
import ProfessionQualification from "./ProfessionQualification";
import * as Yup from "yup";
import { config } from "../../../CommonUtilities/CommonUrl/CommonUrls";
import Sweetalert from "../../../CommonUtilities/CommonPopupAndAlerts/SweetAlerts";
import {
  CommonAxiosGet,
  CommonAxiosPost,
} from "../../../CommonUtilities/CommonAxios/CommonAxios";
import {
  CONTEXT_HEADING,
  CONTEXT_NAME,
  CURRENT_ACADEMIC_YEAR,
  ERROR_MSG,
  HT_Msg,
  Percentage_Msg,
  alphaNumeric_VALIDATION,
} from "../../../CommonUtilities/Validations/RegularExpAndVar";
import TET from "./TET";
import Swal from "sweetalert2";
import moment from "moment";
import PrincipleDetails from "./PrincipleDetails";
import { useDispatch, useSelector } from "react-redux";

export const pgDegreeBasedCourses = [
  1, 2, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 22, 23, 25, 26,
  39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 53, 54, 55, 56, 60, 61, 62, 63, 64,
  65, 66, 67, 99,
];
export const dedCourses = [
  19, 20, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 49, 50, 52, 57, 58,
  59, 69, 70, 71, 72,
];

export default function ApplicationForm({ handleNext }) {
  const dispatch = useDispatch();
  const tabdetails = useSelector(
    (state) => state.reducers.loginreducer.tabdetails,
  );
  const [years, setYears] = useState([]);

  function YearOfPassing() {
    const currentYear = new Date().getFullYear();
    const yearsArray = [];
    for (let year = currentYear; year > 1965; year--) {
      yearsArray.push(year);
    }
    setYears(yearsArray);
  }

  const excludedCodes = [
    "Q30",
    "Q31",
    "Q32",
    "Q33",
    "Q34",
    "Q35",
    "Q36",
    "Q37",
    "Q38",
    "Q39",
    "Q40",
    "Q41",
    "Q42",
    "Q43",
    "Q46",
    "Q102",
  ];

  const currentPqYop = moment().year();

  const ValidationSchema = Yup.object().shape({
    isTelangana: Yup.string().required(ERROR_MSG),
    claimingDistrict: Yup.string().when("isTelangana", {
      is: (isNative) => isNative === "true",
      then: Yup.string().required(ERROR_MSG).nullable(),
      oterwise: Yup.string(),
    }),
    typeOfStudy: Yup.string().required(ERROR_MSG).nullable(),
    district1: Yup.string().required(ERROR_MSG).nullable(),
    district2: Yup.string().required(ERROR_MSG).nullable(),
    district3: Yup.string().required(ERROR_MSG).nullable(),
    district4: Yup.string().required(ERROR_MSG).nullable(),
    district5: Yup.string().required(ERROR_MSG).nullable(),
    district6: Yup.string().required(ERROR_MSG).nullable(),
    district7: Yup.string().required(ERROR_MSG).nullable(),
    localDistCode: Yup.string().required(ERROR_MSG).nullable(),
    isSsc: Yup.string().required(ERROR_MSG).nullable(),
    isInter: Yup.string().required(ERROR_MSG).nullable(),
    sscBoard: Yup.string().when("isSsc", {
      is: (isSsc) => isSsc == "Yes",
      then: Yup.string().required(ERROR_MSG).nullable(),
      oterwise: Yup.string().nullable(),
    }),
    sscMedium: Yup.string().when("isSsc", {
      is: (isSsc) => isSsc == "Yes",
      then: Yup.string().required(ERROR_MSG).nullable(),
      oterwise: Yup.string().nullable(),
    }),
    sscFirstLanguage: Yup.string().when("isSsc", {
      is: (isSsc) => isSsc == "Yes",
      then: Yup.string().required(ERROR_MSG).nullable(),
      oterwise: Yup.string().nullable(),
    }),
    sscHallTicket: Yup.string().when("isSsc", {
      is: (isSsc) => isSsc == "Yes",
      then: Yup.string()
        .required(ERROR_MSG)
        .matches(alphaNumeric_VALIDATION, HT_Msg)
        .nullable()
        .min(4, "Invalid Number")
        .max(15, "Invalid Number"),
      oterwise: Yup.string().nullable(),
    }),
    sscPercentage: Yup.string().when("isSsc", {
      is: (isSsc) => isSsc == "Yes",
      then: Yup.string()
        .required(ERROR_MSG)
        .test("is-valid-mark", "Invalid Marks!", (value) => {
          if (value === null || value === "") return false;

          const num = parseFloat(value);
          const isNumeric = /^(\d+)(\.\d{1})?$/.test(value);

          return isNumeric && num >= 35 && num <= 100;
        })
        .nullable(),
      oterwise: Yup.string().nullable(),
    }),
    // TET------------------------------------------------
    // sscYearOfPass: Yup.string().when("isSsc", {
    //   is: (isSsc) => isSsc === "Yes",
    //   then: Yup.string()
    //     .nullable()
    //     .required(ERROR_MSG)
    //     .test("isLarger", "Invalid Year of Pass", (value, testContext) => {
    //       const { dob } = testContext.parent;
    //       if (!dob || !value) return false;

    //       const dobYear = moment(dob, "YYYY-MM-DD").year();
    //       const passYear = Number(value);
    //       const minYear = dobYear + 14;
    //       const currentYear = moment().year();

    //       if (passYear < minYear) return false;

    //       if (passYear > currentYear)
    //         return testContext.createError({
    //           message: "Year of Passing cannot be in the future",
    //         });

    //       return true;
    //     }),
    //   otherwise: Yup.string().nullable(),
    // }),

    // ****************dsc ssc *******************
    sscYearOfPass: Yup.string().when("isSsc", {
      is: (isSsc) => isSsc == "Yes",
      then: Yup.string()
        .nullable()
        .required(ERROR_MSG)
        .test("isLarger", "Invalid Year of Pass", (value, testContext) => {
          let test_dob = testContext.parent.dob;
          const dobYear = moment(test_dob).year(); // Extract the year from DOB
          const minYear = dobYear + 13; // Minimum valid year
          if (minYear > Number(value)) {
            return false;
          }
          return true;
        }),
      oterwise: Yup.string().nullable(),
    }),

    // interYearOfPass: Yup.string()
    //   .nullable()
    //   .when("isInter", {
    //     is: (isInter) => isInter === "Yes",
    //     then: Yup.string()
    //       .required(ERROR_MSG)
    //       .test("isLarger", "Invalid Year of Pass", (value, testContext) => {
    //         if (!value) return false;

    //         const { sscYearOfPass, dob } = testContext.parent;
    //         const interYear = Number(value);
    //         const sscYear = Number(sscYearOfPass);
    //         const dobYear = moment(dob, "YYYY-MM-DD").year();
    //         const minYear = dobYear + 16;
    //         const currentYear = moment().year();

    //         if (!dob)
    //           return testContext.createError({
    //             message: "Please enter your Date of Birth first",
    //           });

    //         if (sscYear >= interYear || interYear > 2024) return false;
    //         if (interYear < minYear) return false;
    //         if (interYear > currentYear)
    //           return testContext.createError({
    //             message: "Year of Passing cannot be in the future",
    //           });

    //         return true;
    //       }),
    //     otherwise: Yup.string().nullable(),
    //   }),

    // ************dsc  inter ********************
    interYearOfPass: Yup.string()
      .nullable()
      .when("isInter", {
        is: (isInter) => isInter === "Yes",
        then: Yup.string()
          .required(ERROR_MSG)
          .test("isLarger", "Invalid Year of Pass", (value, testContext) => {
            if (!value) return false;

            const sscYear = Number(testContext.parent.sscYearOfPass);

            const interYear = Number(value);
            if (sscYear >= interYear || interYear > 2024) return false;
            let test_dob = testContext.parent.dob;
            const dobYear = moment(test_dob).year(); // Extract DOB year
            const minYear = dobYear + 13; // Minimum valid year

            if (interYear < minYear) return false; // Inter year must be >= DOB + 13

            return true;
          }),
        otherwise: Yup.string().nullable(),
      }),
    interBoard: Yup.string().when("isInter", {
      is: (isInter) => isInter === "Yes",
      then: Yup.string().required(ERROR_MSG).nullable(),
      oterwise: Yup.string().nullable(),
    }),
    interMedium: Yup.string().when("isInter", {
      is: (isInter) => isInter === "Yes",
      then: Yup.string().required(ERROR_MSG).nullable(),
      oterwise: Yup.string().nullable(),
    }),
    interHallTicket: Yup.string().when("isInter", {
      is: (isInter) => isInter === "Yes",
      then: Yup.string()
        .required(ERROR_MSG)
        .matches(alphaNumeric_VALIDATION, HT_Msg)
        .nullable()
        .min(4, "Invalid Number")
        .max(15, "Invalid Number"),
      oterwise: Yup.string().nullable(),
    }),
    interPercentage: Yup.string().when(["isInter"], {
      is: (isInter) => isInter === "Yes",
      then: Yup.string()
        .required(ERROR_MSG)
        .test("is-valid-mark", Percentage_Msg, (value) => {
          if (value === null || value === "") return false;

          const num = parseFloat(value);
          const isNumeric = /^(\d+)(\.\d{1})?$/.test(value);

          return isNumeric && num >= 35 && num <= 100;
        })
        .nullable(),
      // then: Yup.string()
      //   .required(ERROR_MSG)
      //   .test('caste-percentage-validation', Percentage_Msg, (value, context) => {
      //     if (value) {
      //       const { caste } = context.parent;
      //       if (caste === 'OC') {
      //         return Percentage_Validation_35?.test(value);
      //       }
      //     }
      //   }),----------> removed by rakesh sir and sivaram sir 22/4/25
      otherwise: Yup.string().nullable(),
    }),
    interCourse: Yup.string().when("isInter", {
      is: (isInter) => isInter === "Yes",
      then: Yup.string().required(ERROR_MSG).nullable(),
      oterwise: Yup.string().nullable(),
    }),
    interSecondLanguage: Yup.string().when("isInter", {
      is: (isInter) => isInter === "Yes",
      then: Yup.string().required(ERROR_MSG).nullable(),
      oterwise: Yup.string().nullable(),
    }),
    interSubject1: Yup.string().when("isInter", {
      is: (isInter) => isInter === "Yes",
      then: Yup.string()
        .required(ERROR_MSG)
        .test("unique", "Subject  is already selected", (value, context) => {
          const { interSubject2, interSubject3, interSubject4 } =
            context.parent;
          return (
            value !== interSubject2 &&
            value !== interSubject3 &&
            value !== interSubject4
          );
        }),
      oterwise: Yup.string().nullable(),
    }),
    interSubject2: Yup.string().when("isInter", {
      is: (isInter) => isInter === "Yes",
      then: Yup.string()
        .required(ERROR_MSG)
        .test("unique", "Subject  is already selected", (value, context) => {
          const { interSubject1, interSubject3, interSubject4 } =
            context.parent;
          return (
            value !== interSubject1 &&
            value !== interSubject3 &&
            value !== interSubject4
          );
        }),
      oterwise: Yup.string().nullable(),
    }),
    interSubject3: Yup.string().when("isInter", {
      is: (isInter) => isInter === "Yes",
      then: Yup.string()
        .required(ERROR_MSG)
        .test("unique", "Subject  is already selected", (value, context) => {
          const { interSubject1, interSubject2, interSubject4 } =
            context.parent;
          return (
            value !== interSubject1 &&
            value !== interSubject2 &&
            value !== interSubject4
          );
        }),
      oterwise: Yup.string().nullable(),
    }),
    interSubject4: Yup.string().when("isInter", {
      is: (isInter) => isInter === "Yes",
      then: Yup.string()
        .nullable()
        .test("unique", "Subject  is already selected", (value, context) => {
          if (value) {
            const { interSubject1, interSubject2, interSubject3 } =
              context.parent;
            return (
              value !== interSubject1 &&
              value !== interSubject2 &&
              value !== interSubject3
            );
          }
          return true;
        }),
      oterwise: Yup.string().nullable(),
    }),
    isUg: Yup.string().required(ERROR_MSG).nullable(),
    ug: Yup.array().when("isUg", {
      is: "Yes",
      then: Yup.array().of(
        Yup.object().shape({
          univCode: Yup.string().required(ERROR_MSG),
          yearOfPass: Yup.string().when("is_gov_school", {
            is: true,
            then: Yup.string().required(ERROR_MSG).nullable(),
            otherwise: Yup.string()
              .required(ERROR_MSG)
              .nullable()
              .test("isLarger", "", (value, context) => {
                if (!value) return true;
                if (Formik?.values?.is_gov_school === false) {
                  const interYearOfPass = Formik?.values?.interYearOfPass;
                  const sscYearOfPass = Formik?.values?.sscYearOfPass;
                  const isInter = Formik?.values?.isInter;
                  const isSsc = Formik?.values?.isSsc;
                  const { courseCode } = context.parent;

                  const numericValue = parseInt(value, 10);
                  const ssc = parseInt(sscYearOfPass, 10);
                  const inter = parseInt(interYearOfPass, 10);

                  const currentYear = new Date().getFullYear();

                  if (isNaN(numericValue)) {
                    return context.createError({
                      message: "Please enter a valid year",
                    });
                  }

                  if (numericValue > currentYear) {
                    return context.createError({
                      message:
                        "Year of Pass cannot be greater than Current Year",
                    });
                  }

                  if (excludedCodes.includes(courseCode)) {
                    if (isSsc === "No") {
                      return context.createError({
                        message: "This Course require SSC",
                      });
                    }
                    // if (isSsc === "Yes" && numericValue < ssc) {
                    //   return context.createError({
                    //     message: "Year of Pass should not below SSC year",
                    //   });
                    // }
                  } else {
                    if (isSsc === "Yes" && numericValue <= ssc) {
                      return context.createError({
                        message: "Year of Pass must be greater than SSC year",
                      });
                    }
                    if (isInter === "Yes" && numericValue <= inter) {
                      return context.createError({
                        message:
                          "Year of Pass must be greater than Intermediate year",
                      });
                    }
                  }
                }
                return true;
              }),
          }),

          mediumId: Yup.string().required(ERROR_MSG),
          hallTicket: Yup.string()
            .required(ERROR_MSG)
            .nullable()
            .matches(alphaNumeric_VALIDATION, HT_Msg)
            .min(4, "Invalid Number")
            .max(15, "Invalid Number"),
          percentage: Yup.string()
            .required(ERROR_MSG)
            .nullable()
            .test(
              "caste-percentage-validation",
              Percentage_Msg,
              function (value) {
                if (value === null || value === "") return false;
                const isNumeric = /^(\d+)(\.\d{1})?$/.test(value);
                const num = parseFloat(value);
                return isNumeric && num >= 35 && num <= 100;
              },
            )
            .required(ERROR_MSG)
            .nullable(),
          courseCode: Yup.string().required(ERROR_MSG).nullable(),
          subject1: Yup.string().required(ERROR_MSG).nullable(),
          subject2: Yup.string()
            .nullable()
            .test("unique", "Subject is already selected", (value, context) => {
              if (value) {
                const { subject1, subject3, subject4 } = context.parent;

                return (
                  value !== subject1 && value !== subject3 && value !== subject4
                );
              }
              return true;
            }),

          subject3: Yup.string()
            .nullable()
            .test("unique", "Subject is already selected", (value, context) => {
              if (value) {
                const { subject1, subject2, subject4 } = context.parent;
                return (
                  value !== subject1 && value !== subject2 && value !== subject4
                );
              }
              return true;
            }),
          subject4: Yup.string()
            .nullable()
            .test("unique", "Subject is already selected", (value, context) => {
              if (value) {
                const { subject1, subject2, subject3 } = context.parent;
                return (
                  value !== subject1 && value !== subject2 && value !== subject3
                );
              }
              return true;
            }),
          secondLanguage: Yup.string()
            .required(ERROR_MSG)
            .nullable()
            .test("check-courseCode", ERROR_MSG, (value, context) => {
              const { courseCode } = context.parent;
              if (courseCode === "Q99") {
                return true; // If courseCode is 'Q99', skip required validation
              }
              return !!value; // Otherwise, value is required
            }),
        }),
      ),
      otherwise: Yup.array().of(
        Yup.object().shape({
          univCode: Yup.string().nullable(),
          yearOfPass: Yup.string().nullable(),
          mediumId: Yup.string().nullable(),
          hallTicket: Yup.string().nullable(),
          percentage: Yup.string().nullable(),
          courseCode: Yup.string().nullable(),
          subject1: Yup.string().nullable(),
          subject2: Yup.string().nullable(),
          subject3: Yup.string().nullable(),
          subject4: Yup.string().nullable(),
          secondLanguage: Yup.string().nullable(),
        }),
      ),
    }),

    pq: Yup.array().of(
      Yup.object().shape({
        univCode: Yup.string().nullable().required(ERROR_MSG),
        courseCode: Yup.string().nullable().required(ERROR_MSG),
        yearOfPass: Yup.string().when("is_gov_school", {
          is: true,
          then: Yup.string().required(ERROR_MSG).nullable(),
          otherwise: Yup.string()
            .nullable()
            .required(ERROR_MSG)
            .test("isLarger", "Invalid Year of Pass", (value, context) => {
              const formValues = context?.options?.context || {};
              const sscYearOfPass = Formik?.values?.sscYearOfPass || "";
              const interYearOfPass = Formik?.values?.interYearOfPass || "";
              const isInter = Formik?.values?.isInter || "";
              const isSsc = Formik?.values?.isSsc || "";
              const isUg = Formik?.values?.isUg || "";
              const isPg = Formik?.values?.isPg || "";
              const isGov = showIsGovEmp;
              const ugData =
                formValues.ug || context?.from?.[1]?.value?.ug || [];

              const { courseCode } = context.parent;

              if (!value) return true;

              const yearOfPass = parseInt(value, 10);
              if (isNaN(yearOfPass)) return false;
              if (Formik?.values?.is_gov_school === false) {
                const CURRENT_YEAR =
                  CURRENT_ACADEMIC_YEAR || new Date().getFullYear();
                if (yearOfPass > CURRENT_YEAR + 1) return false;
                const interYOP = parseInt(interYearOfPass, 10) || 0;
                const sscYOP = parseInt(sscYearOfPass, 10) || 0;

                const validUgYears = ugData
                  .map((obj) => parseInt(obj?.yearOfPass, 10))
                  .filter((y) => !isNaN(y));

                const maxUgYOP =
                  validUgYears.length > 0 ? Math.max(...validUgYears) : null;
                const minUgYOP =
                  validUgYears.length > 0 ? Math.min(...validUgYears) : null;
                const parsedCourse = parseInt(courseCode, 10);

                const dob = Formik?.values?.dob;
                if (dob) {
                  const ageAtPassing = moment(
                    `${value}-12-31`,
                    "YYYY-MM-DD",
                  ).diff(moment(dob, "YYYY-MM-DD"), "years");
                  if (ageAtPassing < 18) {
                    return context.createError({
                      message: `required min 18 years age`,
                    });
                  }
                }
                if ([40, 42, 46, 47, 44, 43].includes(parsedCourse)) {
                  if (maxUgYOP !== null && yearOfPass === maxUgYOP) {
                    return true;
                  }
                }
                //  Skip validation ONLY for govt employees with special course codes
                // if (isGov && [6, 12, 51, 17].includes(parsedCourse)) {
                //   if (maxUgYOP !== null && yearOfPass === maxUgYOP) {
                //     return false;
                //   }
                //   return true;
                // }
                // 1️⃣ UG-based GOVT special courses
                if (
                  (isUg === "Yes" || isPg === "Yes") &&
                  pgDegreeBasedCourses.includes(parsedCourse)
                ) {
                  // 2️⃣ SSC-based courses (Hindi)
                  if (
                    isSsc === "Yes" &&
                    [1, 2, 9, 10, 11, 13, 15].includes(parsedCourse)
                  ) {
                    if (!(yearOfPass >= sscYOP && yearOfPass <= CURRENT_YEAR)) {
                      return context.createError({
                        message:
                          "Year of Pass should not be earlier than SSC Year for Hindi courses.",
                      });
                    }
                    return true;
                  }

                  if (
                    isInter === "Yes" &&
                    !(yearOfPass > interYOP) &&
                    ![1, 2, 9, 10, 11, 13, 15].includes(parsedCourse) &&
                    ![40, 42, 46, 47, 44, 43].includes(parsedCourse)
                  ) {
                    return context.createError({
                      message:
                        "PQ Year of Pass cannot be before Inter for B.E.D Courses",
                    });
                  }
                  if (
                    !(yearOfPass > minUgYOP && yearOfPass <= CURRENT_YEAR) &&
                    ![40, 42, 46, 47, 44, 43].includes(parsedCourse)
                  ) {
                    return context.createError({
                      message:
                        "Year of pass must be after Degree for B.E.D Courses",
                    });
                  }

                  return true;
                }
                // // 2️⃣ SSC-based courses (Hindi)
                // if (isSsc === "Yes" &&
                //   [1, 2, 9, 10, 11, 13, 15].includes(parsedCourse)
                // ) {
                //   if (!(yearOfPass >= sscYOP && yearOfPass <= CURRENT_YEAR)) {
                //     return context.createError({
                //       message:
                //         "Year of Pass should not be earlier than SSC Year for Hindi courses.",
                //     });
                //   }
                //   return true;
                // }
                // 3️⃣ Inter-based D.Ed courses
                if (isInter === "Yes" && dedCourses?.includes(parsedCourse)) {
                  if (yearOfPass === interYOP) {
                    return context.createError({
                      message:
                        "Year of Pass cannot be same as Intermediate year",
                    });
                  }

                  if (!(yearOfPass > interYOP && yearOfPass <= CURRENT_YEAR)) {
                    return context.createError({
                      message: "Year of Pass must be after Inter",
                    });
                  }

                  return true;
                }

                // 4️⃣ PQ vs UG comparison
                if (minUgYOP !== null && yearOfPass < minUgYOP) {
                  return context.createError({
                    message: "Year of Pass must be greater than UG Year",
                  });
                }

                // 5️⃣ UG - NO && Inter YES
                if (isUg !== "Yes" && yearOfPass <= interYOP) {
                  return context.createError({
                    message: "Year of Pass must be greater than Inter Year",
                  });
                }

                // 6️⃣ Inter - NO && SSC YES
                if (isInter !== "Yes" && yearOfPass <= sscYOP) {
                  return context.createError({
                    message: "Year of Pass must be greater than SSC Year",
                  });
                }
              }
              return true;
            }),
        }),
        /////////////below code 06//11/25
        // yearOfPass: Yup.string()
        //   .nullable()
        //   .required(ERROR_MSG)
        //   .test("isLarger", "Invalid Year of Pass", (value, context) => {
        //     const sscYearOfPass = Formik?.values?.sscYearOfPass || "";
        //     const interYearOfPass = Formik?.values?.interYearOfPass || "";
        //     const isUg = Formik?.values?.isUg || "";
        //     const { courseCode } = context.parent;

        //     if (!value) return true;

        //     const yearOfPass = parseInt(value, 10);
        //     if (isNaN(yearOfPass)) return false;

        //     // Don’t allow year beyond currentYear + 1 (since next year is valid)
        //     if (yearOfPass > CURRENT_ACADEMIC_YEAR) return false;

        //     const interYOP = parseInt(interYearOfPass, 10) || 0;
        //     const ssc = parseInt(sscYearOfPass, 10) || 0;

        //     const maxUgYOP = Formik?.values?.ug?.reduce((max, obj) => {
        //       const yop = parseInt(obj.yearOfPass);
        //       return yop > max ? yop : max;
        //     }, -Infinity);

        //     // Special course code logic
        //     if ([1, 2, 9, 10, 11, 13, 15].includes(parseInt(courseCode))) {
        //       return yearOfPass >= ssc && yearOfPass <= CURRENT_ACADEMIC_YEAR;
        //     }

        //     if ([19, 27, 28, 20, 30, 37, 32, 35, 36, 38, 33, 29].includes(parseInt(courseCode))) {
        //       return yearOfPass >= interYOP && yearOfPass <= CURRENT_ACADEMIC_YEAR;
        //     }

        //     // UG/PG logic
        //     if (isUg === "Yes") {
        //       if (maxUgYOP !== -Infinity && yearOfPass < maxUgYOP) {
        //         return false;
        //       }
        //     } else {
        //       if (yearOfPass <= interYOP) {
        //         return false;
        //       }
        //     }

        //     return true;
        //   }),
        /////////////above code 06//11/25

        // yearOfPass: Yup.string()
        //   .nullable()
        //   .required(ERROR_MSG)
        //   .test('isLarger', 'Invalid Year of Pass', (value, context) => {
        //     const sscYearOfPass = Formik?.values?.sscYearOfPass || "";
        //     const interYearOfPass = Formik?.values?.interYearOfPass || "";
        //     const isUg = Formik?.values?.isUg || "";

        //     const {
        //       courseCode,
        //     } = context.parent;

        //     if (!value) return true;

        //     const yearOfPass = parseInt(value, 10);
        //     if (isNaN(yearOfPass)) return false;

        //     if (yearOfPass > 2025) return false;

        //     const interYOP = parseInt(interYearOfPass, 10) || 0;
        //     const ssc = parseInt(sscYearOfPass, 10) || 0;

        //     const maxUgYOP = Formik?.values?.ug.reduce((max, obj) => {
        //       const yearOfPass = parseInt(obj.yearOfPass); // Ensure to convert to integer if necessary
        //       return yearOfPass > max ? yearOfPass : max;
        //     }, -Infinity);

        //     // Special course code logic
        //     if ([1, 2, 9, 10, 11, 13, 15].includes(parseInt(courseCode))) {
        //       return yearOfPass >= ssc && yearOfPass <= 2025;
        //     }
        //     if ([19, 27, 28, 20, 30, 37, 32, 35, 36, 38, 33, 29].includes(parseInt(courseCode))) {
        //       return yearOfPass >= interYOP && yearOfPass <= 2025;
        //     }

        //     // UG/PG logic
        //     if (isUg === 'Yes') {
        //       if (maxUgYOP !== -Infinity && yearOfPass < maxUgYOP) {
        //         return false;
        //       }
        //     } else {
        //       if (yearOfPass <= interYOP) {
        //         return false;
        //       }
        //     }
        //     return true;
        //   }),
        subject1: Yup.string().required(ERROR_MSG).nullable(),
        subject2: Yup.string()
          .nullable()
          .test("unique", "Subject is already selected", (value, context) => {
            if (value) {
              const { subject1 } = context.parent;
              return value !== subject1;
            }
            return true;
          }),

        hasFinalYearResult: Yup.string()
          .nullable()
          .when("yearOfPass", {
            is: (yop) => parseInt(yop, 10) === 2026,
            then: (schema) => schema.required(ERROR_MSG), // Mandatory only for 2025
            otherwise: (schema) => schema.nullable().notRequired(),
          }),

        // percentage: Yup.string()
        //   .nullable()
        //   .test("validate-percentage", Percentage_Msg, (value, context) => {
        //     const yop = parseInt(context.parent.yearOfPass, 10);
        //     const resultStatus = context.parent.hasFinalYearResult;

        //     // Skip validation for integrated course (UI disables it anyway)
        //     // Skip if 2026 (current academic year)
        //     if (yop === CURRENT_ACADEMIC_YEAR) return true;

        //     // ✅ If 2025 + No → Do NOT require percentage
        //     if (yop === 2026 && resultStatus === "No") return true;

        //     // If 2025 + Yes → percentage must be entered
        //     if (yop === 2026 && resultStatus === "Yes") {
        //       if (!value) return false;
        //     }

        //     // For all other cases (other years) → validate normally
        //     if (!value) return false;

        //     const isNumeric = /^(\d+)(\.\d{1})?$/.test(value);
        //     const num = parseFloat(value);

        //     return isNumeric && num >= 35 && num <= 100;
        //   }),
        percentage: Yup.string()
          .nullable()
          .test("validate-percentage", Percentage_Msg, function (value) {
            const yop = Number(this.parent.yearOfPass);
            const resultStatus = this.parent.hasFinalYearResult;

            if (yop === 2026 && resultStatus === "No") {
              return true;
            }

            if (!value) return false;

            const isNumeric = /^(\d+)(\.\d{1})?$/.test(value);
            const num = parseFloat(value);

            // 2026 + Yes
            if (yop === 2026 && resultStatus === "Yes") {
              return isNumeric && num >= 35 && num <= 100;
            }

            // All other years
            return isNumeric && num >= 35 && num <= 100;
          }),

        // percentage: Yup.string()
        //   .nullable()
        //   .test("caste-percentage-validation", Percentage_Msg, (value, context) => {
        //     const yearOfPass = parseInt(context?.parent?.yearOfPass);

        //     if (yearOfPass === CURRENT_ACADEMIC_YEAR) return true;

        //     // Required if not next year
        //     if (!value) return false;

        //     const isNumeric = /^(\d+)(\.\d{1})?$/.test(value);
        //     const num = parseFloat(value);

        //     return isNumeric && num >= 35 && num <= 100;
        //   })

        //   .when("yearOfPass", {
        //     is: (yop) => parseInt(yop) !== CURRENT_ACADEMIC_YEAR,
        //     then: (schema) => schema.required(ERROR_MSG),
        //     otherwise: (schema) => schema.nullable().notRequired(),
        //   }),

        // percentage: Yup.string().nullable().required(ERROR_MSG).test('caste-percentage-validation', Percentage_Msg, function (value) {
        //   if (value === null || value === '') return false;

        //   const isNumeric = /^(\d+)(\.\d{1})?$/.test(value);
        //   const num = parseFloat(value);

        //   return isNumeric && num >= 35 && num <= 100;
        // }),
        mediumId: Yup.string().required(ERROR_MSG).nullable(),
      }),
    ),
    isPg: Yup.string()
      .required(ERROR_MSG)
      .nullable()
      .test("has-ug", "required degree to select PG.", (value, context) => {
        // Access sibling field directly from context.parent
        let isUg = Formik?.values?.isUg;
        if (value === "Yes" && (isUg === "No" || !isUg)) {
          return context.createError({
            message: "required degree to select PG.",
          });
        }
        return true;
      }),

    // isPg: Yup.string().required(ERROR_MSG).nullable(),
    pg: Yup.array().when("isPg", {
      is: "Yes",
      then: Yup.array().of(
        Yup.object().shape({
          univCode: Yup.string().required(ERROR_MSG),
          yearOfPass: Yup.string().when("is_gov_school", {
            is: true,
            then: Yup.string().required(ERROR_MSG).nullable(),
            otherwise: Yup.string()
              .required(ERROR_MSG)
              .nullable()
              .test("isLarger", "Invalid Year of Pass", function (value) {
                if (value) {
                  const yu_yop = Formik?.values?.ug.reduce((max, obj) => {
                    const yearOfPass = parseInt(obj.yearOfPass); // Ensure to convert to integer if necessary
                    return yearOfPass > max ? yearOfPass : max;
                  }, -Infinity);
                  if (yu_yop >= value) {
                    return false;
                  }
                }
                return true;
              }),
          }),
          mediumId: Yup.string().required(ERROR_MSG).nullable(),
          hallTicket: Yup.string()
            .required(ERROR_MSG)
            .nullable()
            .matches(alphaNumeric_VALIDATION, HT_Msg)
            .min(4, "Invalid Number")
            .max(15, "Invalid Number"),

          percentage: Yup.string()
            .nullable()
            .test(
              "caste-percentage-validation",
              Percentage_Msg,
              function (value) {
                if (value === null || value === "") return false;
                const isNumeric = /^(\d+)(\.\d{1})?$/.test(value);
                const num = parseFloat(value);

                return isNumeric && num >= 35 && num <= 100;
              },
            )
            .required(ERROR_MSG)
            .nullable(),
          courseCode: Yup.string().required(ERROR_MSG).nullable(),
          subject1: Yup.string().required(ERROR_MSG).nullable(),
        }),
      ),
      otherwise: Yup.array().of(
        Yup.object().shape({
          univCode: Yup.string().nullable(),
          yearOfPass: Yup.string().nullable(),
          mediumId: Yup.string().nullable(),
          hallTicket: Yup.string().nullable(),
          percentage: Yup.string().nullable(),
          courseCode: Yup.string().nullable(),
          subject1: Yup.string().nullable(),
        }),
      ),
    }),

    isTet: Yup.string().required(ERROR_MSG).nullable(),
    tet: Yup.array().when("isTet", {
      is: "Yes",
      then: Yup.array().of(
        Yup.object().shape({
          // paper: Yup.string().nullable().test('inter-paper-check', "Inter is required", function (value) {
          //   if (value === null || value === '') return false;
          //   const isinter = Formik.values.isInter;
          //   if (isinter !== "Yes" && (value === "Paper 1A" || value === "Paper 1B")) {
          //     return false
          //   }
          //   else {
          //     return true
          //   }
          // }).required(ERROR_MSG).nullable(),
          paper: Yup.string().nullable().required(ERROR_MSG),
          hallTicket: Yup.string()
            .required(ERROR_MSG)
            .nullable()
            .matches(alphaNumeric_VALIDATION, HT_Msg)
            .min(4, "Invalid Number")
            .max(15, "Invalid Number"),
          tetType: Yup.string().required(ERROR_MSG).nullable(),
          marks: Yup.string()
            .nullable()
            .when("tetType", {
              is: "CTET",
              then: Yup.string()
                .required(ERROR_MSG)
                .test("is-valid-mark", "Invalid Marks!", function (value) {
                  const caste = Formik?.values?.caste;
                  const isExServiceMen = Formik?.values?.isExServiceMen;
                  const isPh = Formik?.values?.isPh;
                  if (value === null || value === "") return false;
                  const num = parseFloat(value);
                  const isNumeric = /^(\d+)(\.\d{1,4})?$/.test(value);

                  if (!isNumeric || num > 150) return false;

                  if (
                    [
                      "SC",
                      "ST",
                      "SC-GR I",
                      "SC-GR II",
                      "SC-GR III",
                      "SC-A",
                      "SC-B",
                      "SC-C",
                    ].includes(caste) ||
                    isPh === "true" ||
                    isExServiceMen === "true"
                  )
                    return num >= 60;
                  if (["BC-A", "BC-B", "BC-C", "BC-D", "BC-E"].includes(caste))
                    return num >= 75;
                  if (caste === "OC") return num >= 90;

                  return false; // default if unknown caste
                }),
              otherwise: Yup.string().nullable(),
            }),
          // marks: Yup.string().nullable().required(ERROR_MSG).test('is-valid-mark', 'Invalid Marks!', function (value) {
          //   const caste = Formik?.values?.caste;
          //   const isExServiceMen = Formik?.values?.isExServiceMen;
          //   const isPh = Formik?.values?.isPh;
          //   if (value === null || value === '') return false;
          //   const num = parseFloat(value);
          //   const isNumeric = /^(\d+)(\.\d{1,4})?$/.test(value);

          //   if (!isNumeric || num > 150) return false;

          //   if ((['SC', 'ST', 'SC-GR I', 'SC-GR II', 'SC-GR III', 'SC-A', 'SC-B', 'SC-C',].includes(caste)) || isPh === 'true' || isExServiceMen === 'true') return num >= 60;
          //   if (['BC-A', 'BC-B', 'BC-C', 'BC-D', 'BC-E'].includes(caste)) return num >= 75;
          //   if (caste === 'OC') return num >= 90;

          //   return false; // default if unknown caste
          // }),

          yearOfPass: Yup.string().when("tetType", {
            is: "CTET",
            then: Yup.string()
              .required(ERROR_MSG)
              .nullable()
              .test("isLarger", "Invalid Year of Pass", function (value) {
                const sscYearOfPass = Formik?.values?.sscYearOfPass;
                if (value && sscYearOfPass > value) return false;
                return true;
              }),
            otherwise: Yup.string().nullable(),
          }),
        }),
      ),
      otherwise: Yup.array().of(
        Yup.object().shape({
          paper: Yup.string().nullable(),
          hallTicket: Yup.string().nullable(),
          yearOfPass: Yup.string().nullable(),
          marks: Yup.string().nullable(),
          tetType: Yup.string().nullable(),
        }),
      ),
    }),
  });

  function onClearFieldValue(name) {
    Formik.setFieldValue(name, "");
  }

  const Formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      isPg: "",
      isUg: "",
      isSsc: "",
      isInter: "",
      isTet: "",
      typeOfStudy: "",
      district1: "",
      district2: "",
      district3: "",
      district4: "",
      district5: "",
      district6: "",
      district7: "",
      localDistCode: "",

      sscBoard: "",
      sscMedium: "",
      sscFirstLanguage: "",
      sscYearOfPass: "",
      sscHallTicket: "",
      sscPercentage: "",

      interBoard: "",
      interMedium: "",
      interSecondLanguage: "",
      interHallTicket: "",
      interPercentage: "",
      caste: "",
      interCourse: "",
      interSubject1: "",
      interSubject2: "",
      interSubject3: "",
      interSubject4: "",
      interYearOfPass: "",

      ug: [
        {
          univCode: "",
          mediumId: "",
          yearOfPass: "",
          hallTicket: "",
          percentage: "",
          subject1: "",
          subject2: "",
          subject3: "",
          subject4: "",
          secondLanguage: "",
          courseCode: "",
        },
      ],
      pg: [
        {
          univCode: "",
          mediumId: "",
          yearOfPass: "",
          hallTicket: "",
          percentage: "",
          subject1: "",
          courseCode: "",
        },
      ],
      pq: [
        {
          univCode: "",
          courseCode: "",
          subject1: "",
          subject2: "",
          yearOfPass: "",
          percentage: "",
          mediumId: "",
          hasFinalYearResult: "",
        },
      ],
      tet: [
        {
          paper: "",
          yearOfPass: "",
          hallTicket: "",
          tetType: "",
          marks: "",
          nameInTet: "",
        },
      ],
      selectedCourses: [],
      isPrincipal: "",
      isGroupB: "",
      isHm: "",
      claimingDistrict: "",
      isTelangana: "",
      isExServiceMen: "",
      isPh: "",
    },
    validationSchema: ValidationSchema,
    validateOnChange: true, // ✅ Correct (no braces)
    validateOnBlur: true, // optional, but good to keep
    context: { Formik: null }, // ✅ will set below
    onSubmit: (values) => {
      // console.log("hello there is error",values)
      if (
        values?.isInter === "Yes" ||
        values?.isUg === "Yes" ||
        values?.isPg === "Yes"
      ) {
        let url = config.url.DSC_URL + "candidate-study-details";
        CommonAxiosPost(url, values).then((res) => {
          if (res?.data?.status === true) {
            Swal.fire({
              text: "Successfully Saved",
              icon: "success",
              confirmButtonColor: "#3085d6",
              allowEnterKey: false,
              allowEscapeKey: false,
              allowOutsideClick: false,
              cancelButtonColor: "#d33",
              showCancelButton: false,
              confirmButtonText: "OK",
              //cancelButtonText: 'Edit'
            }).then((resp) => {
              if (resp.isConfirmed) {
                getData();
                handleNext();
                dispatch({
                  type: "SHOW_TAB_DETAILS",
                  payload: { latestTab: 3, confirm: false },
                });
              }
            });
          } else {
            Sweetalert(res?.data?.sdesc, "error");
          }
        });
      } else {
        Sweetalert("Please select atleast one qualification", "warning");
      }
      // alert("succees")
    },
  });
  function DegreePgBasedPq(is_ug, is_pg) {
    let pq_data = Formik?.values?.pq;
    let filtered_data = pq_data?.filter(
      (val) => !pgDegreeBasedCourses.includes(parseInt(val?.courseCode)),
    );
    let filtered_data_empty =
      filtered_data?.length > 0
        ? filtered_data
        : [
            {
              univCode: "",
              courseCode: "",
              subject1: "",
              subject2: "",
              yearOfPass: "",
              percentage: "",
              mediumId: "",
              hasFinalYearResult: "",
            },
          ];
    Formik?.setFieldValue(
      "pq",
      is_ug === "No" && is_pg === "No" ? filtered_data_empty : pq_data,
    );
  }
  const [showUgData, setUgData] = useState([]);
  const [showPgData, setPgData] = useState([]);
  const [showPqData, setPqData] = useState([]);
  const [sevenData, setsevenData] = useState([]);
  const [tetGetData, setTetGetData] = useState([]);

  const [showIsGovEmp, setIsGovEmp] = useState(null);

  function getData() {
    let villUrl = config.url.DSC_URL + "candidate-study-details";
    CommonAxiosGet(villUrl).then((response) => {
      if (response?.data?.candidatereg_status === true) {
        setIsGovEmp(response?.data?.candidatereg[0]?.is_gov_school);
        Formik.setFieldValue(
          "is_gov_school",
          response?.data?.candidatereg[0]?.is_gov_school,
        );
        Formik.setFieldValue("dob", response?.data?.candidatereg[0]?.dob);
        Formik.setFieldValue(
          "isPh",
          response?.data?.candidatereg[0]?.is_ph ? "true" : "false",
        );
        Formik.setFieldValue(
          "isExServiceMen",
          response?.data?.candidatereg[0]?.is_ex_service_men ? "true" : "false",
        );
        Formik.setFieldValue("caste", response?.data?.candidatereg[0]?.caste);
        const casteId = response?.data?.candidatereg[0]?.certificate_id;

        if (casteId) {
          localStorage.setItem("caste", casteId);
        } else {
          localStorage.removeItem("caste");
          console.warn("No certificate_id found");
        }
      }
      if (response?.data.sevenyear_status === true) {
        let data = response.data;
        Formik.setFieldValue(
          "typeOfStudy",
          data?.candidatereg[0]?.type_of_study,
        );
        Formik.setFieldValue(
          "isPrincipal",
          data?.candidatereg[0]?.is_principal,
        );
        Formik.setFieldValue("isGroupB", data?.candidatereg[0]?.is_group_b);
        Formik.setFieldValue("isHm", data?.candidatereg[0]?.is_hm);
        Formik.setFieldValue("isSsc", data?.candidatereg[0]?.is_ssc);
        Formik.setFieldValue("isUg", data?.candidatereg[0]?.is_ug);
        Formik.setFieldValue("isPg", data?.candidatereg[0]?.is_pg);
        Formik.setFieldValue("isInter", data?.candidatereg[0]?.is_inter);
        Formik.setFieldValue("isTet", data?.candidatereg[0]?.is_tet);

        Formik.setFieldValue("district1", data?.sevenyear[0]?.dist_code);
        Formik.setFieldValue("district2", data?.sevenyear[1]?.dist_code);
        Formik.setFieldValue("district3", data?.sevenyear[2]?.dist_code);
        Formik.setFieldValue("district4", data?.sevenyear[3]?.dist_code);
        Formik.setFieldValue("district5", data?.sevenyear[4]?.dist_code);
        Formik.setFieldValue("district6", data?.sevenyear[5]?.dist_code);
        Formik.setFieldValue("district7", data?.sevenyear[6]?.dist_code);

        setsevenData([
          data?.sevenyear[0]?.dist_code,
          data?.sevenyear[1]?.dist_code,
          data?.sevenyear[2]?.dist_code,
          data?.sevenyear[3]?.dist_code,
          data?.sevenyear[4]?.dist_code,
          data?.sevenyear[5]?.dist_code,
          data?.sevenyear[6]?.dist_code,
        ]);
        if (response?.data?.candidatereg[0]?.local_dist_code === 999) {
          Formik.setFieldValue(
            "isTelangana",
            data?.candidatereg[0]?.is_telangana ? "true" : "false",
          );
          if (data?.candidatereg[0]?.is_telangana) {
            Formik.setFieldValue(
              "claimingDistrict",
              data?.candidatereg[0]?.claiming_district,
            );
          }
        } else {
          Formik.setFieldValue("isTelangana", "false");
        }
      }

      if (response?.data.sscinter_status === true) {
        let data = response.data;
        if (data?.candidatereg[0]?.is_ssc === "Yes") {
          Formik.setFieldValue("sscBoard", data?.sscinter[0]?.ssc_board);
          Formik.setFieldValue("sscMedium", data?.sscinter[0]?.ssc_medium);
          Formik.setFieldValue(
            "sscFirstLanguage",
            data?.sscinter[0]?.ssc_first_language,
          );
          Formik.setFieldValue(
            "sscYearOfPass",
            data?.sscinter[0]?.ssc_year_of_pass,
          );
          Formik.setFieldValue(
            "sscHallTicket",
            data?.sscinter[0]?.ssc_hall_ticket,
          );
          Formik.setFieldValue(
            "sscPercentage",
            data?.sscinter[0]?.ssc_percentage,
          );
        }
        if (data?.candidatereg[0]?.is_inter === "Yes") {
          Formik.setFieldValue("interBoard", data?.sscinter[0]?.inter_board);
          Formik.setFieldValue("interMedium", data?.sscinter[0]?.inter_medium);
          Formik.setFieldValue(
            "interSecondLanguage",
            data?.sscinter[0]?.inter_second_language,
          );
          Formik.setFieldValue(
            "interHallTicket",
            data?.sscinter[0]?.inter_hall_ticket,
          );

          Formik.setFieldValue(
            "interPercentage",
            data?.sscinter[0]?.inter_percentage,
          );
          Formik.setFieldValue(
            "interSubject1",
            data?.sscinter[0]?.inter_subject_1,
          );
          Formik.setFieldValue(
            "interSubject2",
            data?.sscinter[0]?.inter_subject_2,
          );
          Formik.setFieldValue(
            "interSubject3",
            data?.sscinter[0]?.inter_subject_3,
          );
          Formik.setFieldValue(
            "interSubject4",
            data?.sscinter[0]?.inter_subject_4,
          );
          Formik.setFieldValue(
            "interYearOfPass",
            data?.sscinter[0]?.inter_year_of_pass,
          );
          Formik.setFieldValue("interCourse", data?.sscinter[0]?.inter_course);
        }
      }
      if (response?.data?.ugpgpq_status === true) {
        let ugdata = response?.data?.ugpgpq.filter(
          (val) => val.study_type === "UG",
        );
        if (response?.data?.candidatereg[0]?.is_ug === "Yes") {
          setUgData(ugdata);
        } else {
          setUgData([]);
        }
        let pgdata = response?.data?.ugpgpq.filter(
          (val) => val.study_type === "PG",
        );
        if (response?.data?.candidatereg[0]?.is_pg === "Yes") {
          setPgData(pgdata);
        } else {
          setPgData([]);
        }
        let pqdata = response?.data?.ugpgpq.filter(
          (val) => val.study_type === "PQ",
        );
        let filtered_data = pqdata?.filter(
          (val) => !pgDegreeBasedCourses.includes(parseInt(val?.course_code)),
        );
        let isUg = response?.data?.candidatereg[0]?.is_ug === "Yes";
        let isPg = response?.data?.candidatereg[0]?.is_pg === "Yes";
        setPqData(isUg || isPg ? pqdata : filtered_data);
      }
      if (
        response?.data?.candidatereg[0]?.is_tet === "Yes" &&
        response?.data?.tet_status
      ) {
        setTetGetData(response?.data?.tet);
      } else {
        setTetGetData([]);
      }
    });
  }
  // const [isConfirm, setIsConfirm] = useState(false)
  // function getconfirmationData() {
  //   let Url = config.url.DSC_URL + "candidate-confirmation"
  //   CommonAxiosGet(Url).then((res) => {
  //     if (res?.data?.status === true) {
  //       if (res?.data?.data[0]?.basic_education_check === true) {
  //         setIsConfirm(true)
  //       }
  //     }
  //   })
  // }
  const [showCourse, setCourse] = useState([]);
  function CourseData() {
    let Url = config.url.DSC_URL + "ug-pg-courses";
    CommonAxiosGet(Url).then((res) => {
      if (res?.data?.status === true) {
        setCourse(res?.data?.ugpgcourses);
      }
    });
  }
  const [showUniversities, setUniversities] = useState([]);
  function GetUnivData() {
    let Url = config.url.DSC_URL + "universities";
    CommonAxiosGet(Url).then((res) => {
      if (res?.data?.status === true) {
        setUniversities(res?.data?.universities);
      }
    });
  }
  useEffect(() => {
    getData();
    GetUnivData();
    CourseData();
    YearOfPassing();
    // getconfirmationData()
  }, []);

  return (
    <React.Fragment>
      <FormikProvider value={Formik}>
        <Form
          className="form-section"
          onSubmit={Formik.handleSubmit}
          onChange={Formik.handleChange}
        >
          <EducationDetails Formik={Formik} sevenData={sevenData} />
          <div className="personal-head mt-2">
            <span>Academic Details</span>
          </div>
          <div className="personal-row personal-roweducation">
            <Row className="px-2">
              <Col
                xxl={3}
                xl={3}
                lg={4}
                md={6}
                sm={12}
                xs={12}
                className="mb-2 mt-2"
              >
                <Form.Group controlId="">
                  <Form.Label className="input-lable mb-2">
                    Have you studied SSC ?<font color="red">*</font>
                  </Form.Label>
                  <div className="form-border">
                    <Field
                      type="radio"
                      name="isSsc"
                      value="Yes"
                      className="form-sub me-1"
                      onClick={() => {
                        onClearFieldValue("sscBoard");
                        onClearFieldValue("sscMedium");
                        onClearFieldValue("sscFirstLanguage");
                        onClearFieldValue("sscYearOfPass");
                        onClearFieldValue("sscHallTicket");
                        onClearFieldValue("sscPercentage");
                      }}
                    />
                    Yes &nbsp;&nbsp;&nbsp;&nbsp;
                    <Field
                      type="radio"
                      value="No"
                      name="isSsc"
                      className="form-sub me-1"
                      onClick={() => {
                        onClearFieldValue("sscBoard");
                        onClearFieldValue("sscMedium");
                        onClearFieldValue("sscFirstLanguage");
                        onClearFieldValue("sscYearOfPass");
                        onClearFieldValue("sscHallTicket");
                        onClearFieldValue("sscPercentage");
                      }}
                    />
                    No &nbsp;&nbsp;&nbsp;&nbsp;
                  </div>
                  <ErrorMessage
                    name="isSsc"
                    component="div"
                    className="text-error"
                  />
                </Form.Group>
              </Col>
            </Row>
            {Formik?.values?.isSsc === "Yes" && (
              <SSC Formik={Formik} years={years} />
            )}
            <Row className="px-2">
              <Col
                xxl={3}
                xl={3}
                lg={4}
                md={6}
                sm={12}
                xs={12}
                className="mb-2 mt-2"
              >
                <Form.Group controlId="">
                  <Form.Label className="input-lable mb-2">
                    Have you studied Inter ?<font color="red">*</font>
                  </Form.Label>
                  <div className="form-border">
                    <Field
                      type="radio"
                      name="isInter"
                      value="Yes"
                      className="form-sub me-1"
                      onClick={() => {
                        onClearFieldValue("interBoard");
                        onClearFieldValue("interMedium");
                        onClearFieldValue("interSecondLanguage");
                        onClearFieldValue("interHallTicket");
                        onClearFieldValue("interPercentage");
                        onClearFieldValue("interCourse");
                        onClearFieldValue("interSubject1");
                        onClearFieldValue("interSubject2");
                        onClearFieldValue("interSubject3");
                        onClearFieldValue("interSubject4");
                        onClearFieldValue("interYearOfPass");
                      }}
                    />
                    Yes &nbsp;&nbsp;&nbsp;&nbsp;
                    <Field
                      type="radio"
                      value="No"
                      name="isInter"
                      className="form-sub me-1"
                      onClick={() => {
                        onClearFieldValue("interBoard");
                        onClearFieldValue("interMedium");
                        onClearFieldValue("interSecondLanguage");
                        onClearFieldValue("interHallTicket");
                        onClearFieldValue("interPercentage");
                        onClearFieldValue("interCourse");
                        onClearFieldValue("interSubject1");
                        onClearFieldValue("interSubject2");
                        onClearFieldValue("interSubject3");
                        onClearFieldValue("interSubject4");
                        onClearFieldValue("interYearOfPass");

                        //if inter is no then ded  related courses should be delete from pq
                        const filteredPQ = Formik.values.pq.filter(
                          (row) => !dedCourses.includes(Number(row.courseCode)),
                        );
                        Formik.setFieldValue("pq", filteredPQ);
                        //console.log("ff>>", filteredPQ)
                        Formik.setFieldValue("pq", filteredPQ);
                      }}
                    />
                    No &nbsp;&nbsp;&nbsp;&nbsp;
                  </div>
                  <ErrorMessage
                    name="isInter"
                    component="div"
                    className="text-error"
                  />
                </Form.Group>
              </Col>
            </Row>
            {Formik?.values?.isInter === "Yes" && (
              <Inter Formik={Formik} years={years} />
            )}
            <Row className="px-2">
              <Col
                xxl={3}
                xl={3}
                lg={4}
                md={6}
                sm={12}
                xs={12}
                className="mb-2 mt-2"
              >
                <Form.Group controlId="">
                  <Form.Label className="input-lable mb-2">
                    Have you studied Degree ?<font color="red">*</font>
                  </Form.Label>
                  <div className="form-border">
                    <Field
                      type="radio"
                      name="isUg"
                      value="Yes"
                      className="form-sub me-1"
                      onClick={(e) => {
                        setUgData([]);
                        let is_ug = e.target.value;
                        let is_pg = Formik?.values?.isPg;
                        DegreePgBasedPq(is_ug, is_pg);
                        Formik.setFieldValue("ug", [
                          {
                            univCode: "",
                            mediumId: "",
                            yearOfPass: "",
                            hallTicket: "",
                            percentage: "",
                            subject1: "",
                            subject2: "",
                            subject3: "",
                            subject4: "",
                            secondLanguage: "",
                            courseCode: "",
                          },
                        ]);
                      }}
                    />
                    Yes &nbsp;&nbsp;&nbsp;&nbsp;
                    <Field
                      type="radio"
                      value="No"
                      name="isUg"
                      className="form-sub me-1"
                      onClick={(e) => {
                        setUgData([]);
                        let is_ug = e.target.value;
                        let is_pg = Formik?.values?.isPg;
                        DegreePgBasedPq(is_ug, is_pg);

                        Formik.setFieldValue("ug", [
                          {
                            univCode: "",
                            mediumId: "",
                            yearOfPass: "",
                            hallTicket: "",
                            percentage: "",
                            subject1: "",
                            subject2: "",
                            subject3: "",
                            subject4: "",
                            secondLanguage: "",
                            courseCode: "",
                          },
                        ]);
                      }}
                    />
                    No &nbsp;&nbsp;&nbsp;&nbsp;
                  </div>
                  <ErrorMessage
                    name="isUg"
                    component="div"
                    className="text-error"
                  />
                </Form.Group>
              </Col>
            </Row>
            {Formik?.values?.isUg === "Yes" && (
              <Degree
                setPqData={setPqData}
                Formik={Formik}
                years={years}
                showUgData={showUgData}
                getData={getData}
                showCourse={showCourse}
                showUniversities={showUniversities}
              />
            )}
            <Row className="px-2">
              <Col
                xxl={3}
                xl={3}
                lg={4}
                md={6}
                sm={12}
                xs={12}
                className="mb-2 mt-2"
              >
                <Form.Group controlId="">
                  <Form.Label className="input-lable mb-2">
                    Have you studied PG?<font color="red">*</font>
                  </Form.Label>
                  <div className="form-border">
                    <Field
                      type="radio"
                      name="isPg"
                      value="Yes"
                      className="form-sub me-1"
                      onClick={(e) => {
                        let is_pg = e.target.value;
                        let is_ug = Formik?.values?.isUg;
                        DegreePgBasedPq(is_ug, is_pg);
                        setPgData([]);
                        Formik.setFieldValue("pg", [
                          {
                            univCode: "",
                            mediumId: "",
                            yearOfPass: "",
                            hallTicket: "",
                            percentage: "",
                            subject1: "",
                            courseCode: "",
                          },
                        ]);
                      }}
                    />
                    Yes &nbsp;&nbsp;&nbsp;&nbsp;
                    <Field
                      type="radio"
                      value="No"
                      name="isPg"
                      className="form-sub me-1"
                      onClick={(e) => {
                        let is_pg = e.target.value;
                        let is_ug = Formik?.values?.isUg;
                        DegreePgBasedPq(is_ug, is_pg);
                        setPgData([]);
                        Formik.setFieldValue("pg", [
                          {
                            univCode: "",
                            mediumId: "",
                            yearOfPass: "",
                            hallTicket: "",
                            percentage: "",
                            subject1: "",
                            courseCode: "",
                          },
                        ]);
                      }}
                    />
                    No &nbsp;&nbsp;&nbsp;&nbsp;
                  </div>
                  <ErrorMessage
                    name="isPg"
                    component="div"
                    className="text-error"
                  />
                </Form.Group>
              </Col>
            </Row>
            {Formik?.values?.isPg === "Yes" && (
              <PG
                Formik={Formik}
                years={years}
                showPgData={showPgData}
                showCourse={showCourse}
                showUniversities={showUniversities}
              />
            )}
            <Row className="px-2">
              <Col
                xxl={3}
                xl={3}
                lg={4}
                md={6}
                sm={12}
                xs={12}
                className="mb-2 mt-2"
              >
                <Form.Group controlId="">
                  <Form.Label className="input-lable mb-2">
                    Have you written APTET?<font color="red">*</font>
                  </Form.Label>
                  <div className="form-border">
                    <Field
                      type="radio"
                      name="isTet"
                      value="Yes"
                      className="form-sub me-1"
                      onClick={() => {
                        Formik.setFieldValue("tet", [
                          {
                            paper: "",
                            hallTicket: "",
                            yearOfPass: "",
                            tetType: "",
                            marks: "",
                            nameInTet: "",
                          },
                        ]);
                      }}
                    />
                    Yes &nbsp;&nbsp;&nbsp;&nbsp;
                    <Field
                      type="radio"
                      value="No"
                      name="isTet"
                      className="form-sub me-1"
                      onClick={() => {
                        Formik.setFieldValue("tet", [
                          {
                            paper: "",
                            hallTicket: "",
                            yearOfPass: "",
                            tetType: "",
                            marks: "",
                            nameInTet: "",
                          },
                        ]);
                      }}
                    />
                    No &nbsp;&nbsp;&nbsp;&nbsp;
                  </div>
                  <ErrorMessage
                    name="isTet"
                    component="div"
                    className="text-error"
                  />
                </Form.Group>
              </Col>
            </Row>
            {Formik?.values?.isTet === "Yes" && (
              <TET Formik={Formik} tetGetData={tetGetData} />
            )}
            <ProfessionQualification
              Formik={Formik}
              years={years}
              setPqData={setPqData}
              showPqData={showPqData}
              showUniversities={showUniversities}
              showIsGovEmp={showIsGovEmp}
            />
            {Formik?.values?.isPg === "Yes" && CONTEXT_HEADING === "DSC" && (
              <PrincipleDetails Formik={Formik} />
            )}
            {tabdetails?.confirm === false && (
              <div className="floa-end text-end w-100 mb-4">
                <Button
                  variant="success"
                  type="submit"
                  className="submit-btn btn-primary"
                >
                  Save & Continue
                </Button>
              </div>
            )}{" "}
          </div>
        </Form>
      </FormikProvider>
    </React.Fragment>
  );
}
